import React from 'react'

const Link = ( props ) => {

  return (
    <a href={props.link ?? '#'} className={props.class ?? ''} {...props}>
        { props.children && (
            props.children
        )}
    </a>
  )
}

export default Link